import MapView from 'react-native-web-maps'
export default MapView